import { useAuthStore } from '@/website/store/AuthStore';
import { JoveProjectTypeEnum } from '@jove-frontend/enums';
import { JoveDialog } from '@jove-frontend/mui';
import { ChooseUserJumpPortalView } from '@jove-frontend/uikit';
import { Box } from '@mui/material';

interface ChooseUserPortalDialogProps {
  close?: () => void;
  dialogContainerWidth?: string;
  hidePortalListKey?: string[];
}
const ChooseUserPortalDialog = (props: ChooseUserPortalDialogProps) => {
  const { close, dialogContainerWidth, hidePortalListKey = [] } = props;
  const [{ user, userRoles }] = useAuthStore(({ state }) => [state]);

  return (
    <JoveDialog.Wrapper open={true} containerWidth={dialogContainerWidth || '640px'} close={close} className="relative">
      <JoveDialog.Header title="Choose portal" close={close}></JoveDialog.Header>
      <JoveDialog.Content>
        <Box className="px-4">
          <ChooseUserJumpPortalView
            productSource={JoveProjectTypeEnum.website}
            user={user}
            userRoles={userRoles}
            confirmJump={close}
            hidePortalListKey={hidePortalListKey}
            hideLogoutButton
            forceJumpWhenSelected
          />
        </Box>
      </JoveDialog.Content>
    </JoveDialog.Wrapper>
  );
};

export default ChooseUserPortalDialog;
